import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lib-throbbing-balls',
  imports: [],
  templateUrl: './throbbing-balls.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThrobbingBallsComponent {}
